import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ApiIcon(props: IconProps) {
    return <Icon {...props} iconKey={"api"}/>
}
